module.exports = __webpack_public_path__ + "img/logo.0ff1ce39.png";